<div *ngIf="profileAddressSettings.Address1.Visible">
  <label class="control-label">{{ profileAddressSettings.Address1.LabelText }}</label>
  <input type="text" class="form-control" />
</div>

<div *ngIf="profileAddressSettings.Address2.Visible">
  <label class="control-label">{{ profileAddressSettings.Address2.LabelText }}</label>
  <input type="text" class="form-control" />
</div>

<div *ngIf="profileAddressSettings.City.Visible">
  <label class="control-label">{{ profileAddressSettings.City.LabelText }}</label>
  <input type="text" class="form-control" />
</div>

<div *ngIf="profileAddressSettings.State.Visible">
  <label class="control-label">{{ profileAddressSettings.State.LabelText }}</label>
  <input type="text" class="form-control" />
</div>

<div *ngIf="profileAddressSettings.Zip.Visible">
  <label class="control-label">{{ profileAddressSettings.Zip.LabelText }}</label>
  <input type="text" class="form-control" />
</div>

<div *ngIf="profileAddressSettings.ZipExt.Visible">
  <label class="control-label">{{ profileAddressSettings.ZipExt.LabelText }}</label>
  <input type="text" class="form-control" />
</div>

<div *ngIf="profileAddressSettings.County.Visible">
  <label class="control-label">{{ profileAddressSettings.County.LabelText }}</label>
  <input type="text" class="form-control" />
</div>

<div *ngIf="profileAddressSettings.Country.Visible">
  <label class="control-label">{{ profileAddressSettings.Country.LabelText }}</label>
  <input type="text" class="form-control" />
</div>
